import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { IconPlus } from 'components/icons/plus';
import { ModalHeading } from 'components/modal';

export const StyledModalHeader = styled(ModalHeading)`
  margin: 1rem auto;
  font-size: 1.85rem;
  max-width: 100%;
  white-space: initial;
`;

export const StyledForm = styled.form`
  margin-block-end: 0.5rem;
  width: 100%;
`;

export const StyledAddressLine1 = styled.p`
  font-size: 1.0625rem;
  flex-grow: 1;
  font-weight: 900;
  margin: 0;
`;

export const StyledAddressLine2 = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  flex-grow: 1;
  margin: 0;
`;

export const StyledPostalCode = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  flex-grow: 1;
  margin: 0;
`;

export const RadioButtonContainer = styled.div`
  width: 100%;
`;

export const TypesAddressListWrapper = styled.div`
  height: 100%;
  width: 100%;
  padding-block-start: 3rem;
`;

export const TypesAddressWrapper = styled.div`
  height: 5rem;
  padding-block-start: 0;
  display: flex;
  align-items: center;
  margin-inline-start: 1rem;
`;

export const ContainerRadioButton = styled.div`
  flexdirection: 'column';
`;

export const ContainerOtherLocation = styled.div`
  height: 5rem;
  display: flex;
  align-items: center;
`;

export const StyledOtherLocation = styled.p`
  font-size: 1rem;
  flex-grow: 1;
  font-weight: 700;
  margin-inline-start: 7px;
`;

export const PlusIcon = styled(IconPlus)`
  width: 20px;
  display: inline-block;
  margin: auto;
  fill: ${Styles.color.black};
  margin-inline-start: 1rem;
`;

export const StyledActionButton = styled(ActionButton)<{ $isWhiteBGFlagOn: boolean }>`
  background-color: ${p => p.$isWhiteBGFlagOn && p.theme.primaryBackground};
`;
